import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ErrorLayout } from '../../components/ErrorLayout';
import { ErrorScreen } from '../../components/ErrorScreen';

export const ErrorPage: React.FC = () => (
  <>
    <Helmet>
      <title>Something went wrong</title>
    </Helmet>
    <ErrorLayout>
      <ErrorScreen />
    </ErrorLayout>
  </>
);
